export const API_ADDRESS_PROD = 'https://api.mathproficiencytest.ca';
export const API_ADDRESS_LOCAL = 'http://localhost:3030';
export const API_ADDRESS_XQC1 = 'https://xqc1-api.mathproficiencytest.ca';
export const API_ADDRESS_QC1 = 'https://qc1-api.mathproficiencytest.ca';
export const API_ADDRESS_QC3 = 'https://qc3-api.mathproficiencytest.ca';
